import { useFormContext } from 'react-hook-form';
import { CommanderFormProps, useHandledDialogFormControls } from '@mews-commander/form';
import { SelectionCardGroup, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { AssignPropertiesFieldNames, AssignPropertiesSegment } from '../types';
import { assignPropertiesDefaultValues, AssignPropertiesFormValues, assignPropertiesResolver } from '../schemas';
import { useAssignPropertyContext } from '../contexts';
import { PropertyGroupSelectField, PropertySelectField } from '../../../../components/enterprise';

export const AssignPropertiesForm = ({ ...props }: CommanderFormProps) => {
    const { assignProperties } = useAssignPropertyContext();
    const { renderFormContent } = useHandledDialogFormControls<AssignPropertiesFormValues>({
        id: `assign-cancellation-policy-to-property`,
        ...props,
        onSubmit: assignProperties,
        resolver: assignPropertiesResolver,
        defaultValues: assignPropertiesDefaultValues,
    });

    return renderFormContent(<AssignPropertiesFormContent />);
};

const AssignPropertiesFormContent = () => {
    const { watch, setValue } = useFormContext<AssignPropertiesFormValues>();
    const selectedControlValue = watch(AssignPropertiesFieldNames.Segment);

    const { assignedPropertyGroupIds, assignedPropertyIds } = useAssignPropertyContext();

    return (
        <Stack spacing="400" vertical>
            <SelectionCardGroup
                templateColumns="repeat(2, 1fr)"
                type="radio"
                onChange={(_, value) => setValue(AssignPropertiesFieldNames.Segment, value as AssignPropertiesSegment)}
                inputValue={selectedControlValue}
                options={[
                    {
                        label: lt('PropertyGroupPlural'),
                        name: AssignPropertiesSegment.PropertyGroups,
                        value: AssignPropertiesSegment.PropertyGroups,
                    },
                    {
                        label: lt('Properties'),
                        name: AssignPropertiesSegment.Properties,
                        value: AssignPropertiesSegment.Properties,
                    },
                ]}
            />
            {selectedControlValue === AssignPropertiesSegment.PropertyGroups ? (
                <PropertyGroupSelectField
                    filteredPropertyGroupIds={assignedPropertyGroupIds}
                    helper={lt('CancellationPolicyAssignPropertyGroupsHint')}
                    multiselect
                    required
                    shouldUnregister
                />
            ) : null}
            {selectedControlValue === AssignPropertiesSegment.Properties ? (
                <PropertySelectField filteredPropertyIds={assignedPropertyIds} required multiselect shouldUnregister />
            ) : null}
        </Stack>
    );
};
